import ENV_VARS from '@/config'
import { get, post, del } from '@/ports/api'

const { BACKEND_SERVER } = ENV_VARS

export const addPaymentMethod = post(`${BACKEND_SERVER}/plans/payment_methods`)

export const deletePaymentMethod = del(`${BACKEND_SERVER}/plans/payment_methods/%paymentMethodId%`)

export const getPaymentMethod = get(`${BACKEND_SERVER}/plans/payment_methods`, { noLoading: true })

export const getPlan = get(`${BACKEND_SERVER}/plans/subscription/category/base`, {
  noLoading: true
})
